import React from 'react';

import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import Page from '../../components/Page/Page';
import { SignUpPasswordChange } from '../../sections/auth/SignUpPasswordChange';

const SignUpPasswordChang = () => {
  return (
    <Page title="Darum | SignIn">
      <AuthLayout
        formHeaderTitle="Hello"
        formHeaderDescription="Set your password"
      >
        <SignUpPasswordChange />
      </AuthLayout>
    </Page>
  );
};

export default SignUpPasswordChang;
